import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Unstable_Grid2';

export const Wrapper = styled(Grid)``;
